export const BEFORE_FETCH_LEADER_BOARD = "BEFORE_FETCH_LEADER_BOARD";
export const FETCH_LEADER_BOARD = "FETCH_LEADER_BOARD";
export const NETWORK_ERROR_FETCHING_LEADER_BOARD = "NETWORK_ERROR_FETCHING_LEADER_BOARD";